"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

function When(_ref) {
  var isTruthy = _ref.isTruthy,
      children = _ref.children;

  if (!isTruthy) {
    return null;
  }

  return children;
}

var _default = /*#__PURE__*/(0, _react.memo)(When);

exports.default = _default;